import $ from 'jquery';

Dropzone.autoDiscover = false;
import 'dropzone';

export const presencesGallery = () => {
  const _token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  const challengeId = document.querySelector('[name="id"]').value;

  new Dropzone('#myDropzone', {
    url: `${window.location.origin}/acoes-disponiveis/${challengeId}/relatorio/lista-de-presenca/upload-fotos`,
    paramName: 'gallery',
    maxFilesize: 20,
    maxFiles: 50,
    acceptedFiles: 'image/*,video/mp4',
    params: {
      _token: _token,
    },
    addRemoveLinks: true,
    dictDefaultMessage: 'Para enviar fotos e videos clique ou solte aqui',
    dictCancelUpload: 'Cancelar o envio',
    dictRemoveFile: 'Remover',
    dictMaxFilesExceeded: 'Você já adicionou um arquivo',
    dictFileTooBig: 'Arquivo muito grande',
    dictInvalidFileType: 'Este arquivo não é válido',
    init: function () {
      this.on('sending', function (file, response) {
        $('#o-btn--save').attr('disabled');
      });
      this.on('success', function (file, response) {
        $('.added_photos').append(
          '<input type="hidden" data-name="' + file.name + '" name="gallery[]" value="' + response + '"/>'
        );
        $('#o-btn--save').removeAttr('disabled');
      });
      this.on('removedfile', function (file, response) {
        $("input[name='gallery[]']").each(function () {
          if ($(this).attr('data-name') == file.name) {
            $(this).remove();
          }
        });
      });
    },
  });
};
